// 如果把注册路由的代码插入到云枢的源码中，升级云枢的就需要做大量的代码合并冲突、手工解决冲突
// 自己新建的文件，会减少很多烦恼
export default {
    fileView: {
        path: "/fileView",
        name: "fileView",
        component: () => import("./views/fileView/index.vue"),
    },
    testCWork: {
        path: "/testCWork",
        name: "testCWork",
        component: () => import("./views/test/cwork.vue"),
    },
    danganDetail: {
        path: "/dangan-detail",
        name: "danganDetail",
        component: () => import("./views/dangan-detail/index.vue"),
    },
    rxArchiveDetail: {
        path: "/rxArchive-detail",
        name: "rxArchiveDetail",
        component: () => import("./views/rxArchive-detail/index.vue"),
    },
    conference: {
        path: "/conference",
        name: "conference",
        component: () => import("./views/conference/index.vue"),
    },
    borrowDetail: {
        path: "/borrow-detail",
        name: "danganDetail",
        component: () => import("./views/borrow-detail/index.vue"),
    },
    topicBorrowDetail: {
        path: "/topicborrow-detail",
        name: "danganDetail",
        component: () => import("./views/topic-borrow-detail/index.vue"),
    },
    myarichives: {
        path: "/myarchives",
        name: "myarchives",
        component: () => import("./views/myarchives/index.vue"),
    },
    danganDetailH5: {
        path: "/dangan-detail-h5",
        name: "danganDetailH5",
        component: () => import("./views/dangan-detail-h5/index.vue"),
    },
    topicsDetail: {
        path: "/topics-detail",
        name: "topicsDetailH5",
        component: () => import("./views/topics-detail/index.vue"),
    },
    postDetail: {
        path: "/post-detail",
        name: "postDetail",
        component: () => import("./views/dangan-detail-post/detail/index.vue"),
    },
    postDetailNew: {
        path: "/post-detail-new",
        name: "postDetailNew",
        component: () => import("./views/dangan-detail-post-new/detail/index.vue"),
    },
    preDeptPlan: {
        path: "/predeptplan",
        name: "preDeptPlan",
        component: () => import("./views/predeptplan/index.vue"),
    },
    riskfieldtable: {
        path: "/riskfieldtable",
        name: "riskfieldtable",
        component: () => import("./views/riskfieldtable/index.vue"),
    },
    postStart2: {
        path: "/post-start2",
        name: "postStart2",
        component: () => import("./views/dangan-detail-post/post-start/index.vue"),
    },
    postStartNew2: {
        path: "/post-start-new2",
        name: "postStartNew2",
        component: () => import("./views/dangan-detail-post-new/post-start-new/index.vue"),
    },
    topicBorrow: {
        path: "/topic-borrow",
        name: "topicBorrow",
        component: () => import("./views/topic-borrow/index.vue"),
    },
    relevanceFlow: {
        path: "/relevance-flow",
        name: "relevanceFlow",
        component: () => import("./views/relevance-flow/index.vue"),
    },
    application: [
        {
            path: "custom-list",
            name: "customList",
            component: () => import("./views/custom-list/index.vue"),
        },
        {
            path: "testApplication/:schemaCode",
            name: "testApplication",
            component: () => import("./views/application-list.vue"),
        },
        {
            path: "archives/list/:schemaCode1",
            name: "list",
            component: () => import("@/../extends/views/archives/list.vue"),
        },
        {
            path: "archives/information/:schemaCode1",
            name: "archivalInformation",
            component: () => import("@/../extends/views/archivalInformation/list.vue"),
        },
        {
            path: "departmentHead/list/:schemaCode1/:recordType/:schemaCode2/:pageType",
            name: "departmentHead",
            component: () => import("./views/department-head/department-head.vue"),
        },
        {
            path: "fullFileSimplification/:id/:type",
            name: "fullFileSimplification",
            component: () => import("./views/full-file-simplification/list.vue"),
        },
        {
            path: "project-file",
            name: "projectFile",
            component: () => import("./views/project-file/index.vue"),
        },
        {
            path: "post-start",
            name: "postStart",
            component: () => import("./views/dangan-detail-post/post-start/index.vue"),
        },
        {
            path: "post-start-new",
            name: "postStartNew",
            component: () => import("./views/dangan-detail-post-new/post-start-new/index.vue"),
        },
        {
            path: "work-dashboard",
            name: "work-dashboard",
            component: () => import("./views/dashboard/dashboard.vue"),
        },
        {
            path: "dangan-detail-post",
            name: "danganDetailPost",
            component: () => import("./views/dangan-detail-post/index.vue"),
        },
        {
            path: "dangan-detail-post-new",
            name: "danganDetailPost",
            component: () => import("./views/dangan-detail-post-new/index.vue"),
        },
        {
            path: "dangan-borrow/:schemaCodeName",
            name: "danganBorrow",
            component: () => import("./views/dangan-borrow/index.vue"),
        },
        {
            path: "topic-borrow",
            name: "topicBorrow",
            component: () => import("./views/topic-borrow/index.vue"),
        },
        // {
        //   path: "myarichives",
        //   name: "myarichives",
        //   component: () => import("./views/myarchives/index.vue"),
        // },
        {
            path: "document-data-base",
            name: "documentDataBase",
            component: () => import("./views/document-data/index.vue"),
        },
    ],
};
